var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }(); /* eslint no-use-before-define: 1, no-console: 0 */

var _episodes = require('./episodes');

var _episodes2 = _interopRequireDefault(_episodes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/**
  * This is for load time metrics.
  */

module.exports = function (Tracking) {
  var rum = {};

  /*
   * Public functions.
   * -----------------
   */

  /*
   * Alert Rum that the page is done.
   */

  rum.done = function () {
    _episodes2['default'].done();
    track();
    return true;
  };

  /*
   * Prints measurements to the console.
   */

  var rumPrintMsgExtras = {
    backend: ' (firstbyte - starttime)',
    render: ' (domready - firstbyte)',
    total_ready_time: ' (domready - starttime)',
    frontend: ' (onload - firstbyte)',
    page_load_time: ' (onload - starttime)',
    total_load_time: ' (done - starttime)',
    starttime_to_dom_interactive: ' (domInteractive - starttime)'
  };
  rum.print = function () {
    if (global.console && global.console.log) {
      var measures = _episodes2['default'].getMeasures();

      Object.entries(measures).forEach(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 2),
            name = _ref2[0],
            measure = _ref2[1];

        var msg = String(name) + ': ' + String(measure) + 'ms';
        console.log('' + msg + String(rumPrintMsgExtras[name] || ''));
      });
    }
  };

  rum.measures = function () {
    return _episodes2['default'].getMeasures();
  };

  // Expose EPISODES method to set time marker.
  rum.mark = function (markName, markTime) {
    return _episodes2['default'].mark(markName, markTime);
  };

  // Expose EPISODES method to measure an episode.
  rum.measure = function (episodeName, startNameOrTime, endNameOrTime) {
    return _episodes2['default'].measure(episodeName, startNameOrTime, endNameOrTime);
  };

  /*
   * Private helpers.
   * ----------------
   */

  function getPerformance() {
    return window.performance || window.mozPerformance || window.msPerformance || window.webkitPerformance || {};
  }

  function track() {
    var data = rum.measures();

    data = Object.assign({
      www_cdn_provider: window.WWW_CDN_PROVIDER || 'NotFound',
      muscache_cdn_provider: window.MUSCACHE_CDN_PROVIDER || 'NotFound'
    }, data);

    // Wrap in a try-catch due to this issue: https://bugzilla.mozilla.org/show_bug.cgi?id=1045096
    try {
      var performance = getPerformance();

      data = Object.assign({
        cookie_size: document.cookie.length
      }, data);

      if (performance.getEntriesByType) {
        var resources = performance.getEntriesByType('resource');

        // If a request takes less than 30ms, it was probably cached locally.
        var cachedResources = resources.reduce(function (memo, val) {
          return val.duration < 30 ? memo + 1 : memo;
        }, 0);

        data = Object.assign({
          cached_resources: cachedResources,
          total_resources: resources.length
        }, data);
      }
    } catch (e) {/**/}

    Tracking.logEvent({
      event_name: 'pageload',
      event_data: data
    });
  }

  function addEpisode(episode, startTime, endTime) {
    // Wrap in a try-catch due to this issue: https://bugzilla.mozilla.org/show_bug.cgi?id=1045096
    try {
      var performance = getPerformance();
      var timing = performance.timing || {};

      if (typeof timing[startTime] === 'number' && typeof timing[endTime] === 'number' && timing[startTime] > 0 && timing[endTime] >= timing[startTime]) {
        _episodes2['default'].measure(episode, timing[startTime], timing[endTime]);
      }
    } catch (e) {/**/}
  }

  /*
   * Episodes hooks.
   * ---------------
   */

  if (global.document) {
    _episodes2['default'].init();
  }

  if (window.sherlock_firstbyte == null) {
    if (window.console && console.warn) {
      var msg = 'WARNING: Missing sherlock_firstbyte. Bailing from RUM tracking.';
      console.warn(msg);
    }
    return undefined;
  }

  // Mark the "firstbyte".
  // Pass in an explicit time value for "firstbyte".
  _episodes2['default'].mark('firstbyte', window.sherlock_firstbyte);

  // Measure "backend" = (firstbyte - starttime)
  _episodes2['default'].measure('backend', 'starttime', 'firstbyte');

  _episodes2['default'].addEventListener('load', function () {
    _episodes2['default'].mark('load');
    _episodes2['default'].measure('frontend', 'firstbyte', 'load');

    // add dominteractive (guaranteed to happen before load)
    // note the caveats of domInteractive:
    // www.stevesouders.com/blog/2015/08/07/dominteractive-is-it-really/
    var timing = getPerformance().timing || {};

    _episodes2['default'].measure('starttime_to_dom_interactive', 'starttime', timing.domInteractive);

    _episodes2['default'].measure('navigationstart_to_unloadeventstart', timing.navigationStart, timing.unloadEventStart);

    _episodes2['default'].measure('unloadeventstart_to_unloadeventend', timing.unloadEventStart, timing.unloadEventEnd);

    _episodes2['default'].measure('unloadeventend_to_redirectstart', timing.unloadEventEnd, timing.redirectStart);

    _episodes2['default'].measure('redirectstart_to_redirectend', timing.redirectStart, timing.redirectEnd);

    _episodes2['default'].measure('redirectend_to_fetchstart', timing.redirectEnd, timing.fetchStart);

    _episodes2['default'].measure('fetchstart_to_domainlookupstart', timing.fetchStart, timing.domainLookupStart);

    _episodes2['default'].measure('domainlookupstart_to_domainlookupend', timing.domainLookupStart, timing.domainLookupEnd);

    _episodes2['default'].measure('domainlookupend_to_connectstart', timing.domainLookupEnd, timing.connectStart);

    _episodes2['default'].measure('connectstart_to_connectend', timing.connectStart, timing.connectEnd);

    _episodes2['default'].measure('connectend_to_secureconnectionstart', timing.connectEnd, timing.secureConnectionStart);

    _episodes2['default'].measure('secureconnectionstart_to_requeststart', timing.secureConnectionStart, timing.requestStart);

    _episodes2['default'].measure('requeststart_to_responsestart', timing.requestStart, timing.responseStart);

    _episodes2['default'].measure('responsestart_to_responseend', timing.responseStart, timing.responseEnd);

    _episodes2['default'].measure('responseend_to_domloading', timing.responseEnd, timing.domLoading);

    _episodes2['default'].measure('domloading_to_dominteractive', timing.domLoading, timing.domInteractive);

    _episodes2['default'].measure('dominteractive_to_domcontentloadedeventstart', timing.domInteractive, timing.domContentLoadedEventStart);

    _episodes2['default'].measure('domcontentloadedeventstart_to_domcontentloadedeventend', timing.domContentLoadedEventStart, timing.domContentLoadedEventEnd);

    _episodes2['default'].measure('domcontentloadedeventend_to_domcomplete', timing.domContentLoadedEventEnd, timing.domComplete);

    _episodes2['default'].measure('domcomplete_to_loadeventstart', timing.domComplete, timing.loadEventStart);

    _episodes2['default'].measure('loadeventstart_to_loadeventend', timing.loadEventStart, timing.loadEventEnd);

    _episodes2['default'].measure('domloading_to_loadeventstart', timing.domLoading, timing.loadEventStart);

    _episodes2['default'].measure('dominteractive_to_domcontentloaded', timing.domInteractive, timing.domContentLoaded);

    track();
  }, false);

  document.addEventListener('DOMContentLoaded', function () {
    _episodes2['default'].mark('domready');
    _episodes2['default'].measure('render', 'firstbyte', 'domready');
    _episodes2['default'].measure('total_ready_time', 'starttime', 'domready');
  });

  // Additional measurements from Navigation Timing
  addEpisode('redirect_time', 'redirectStart', 'redirectEnd');
  addEpisode('dns_lookup', 'domainLookupStart', 'domainLookupEnd');
  addEpisode('tcp_connect', 'connectStart', 'connectEnd');
  addEpisode('ssl_negotiation', 'secureConnectionStart', 'connectEnd');
  addEpisode('server_response_time', 'requestStart', 'responseStart');
  addEpisode('content_download', 'responseStart', 'responseEnd');

  return rum;
};


//////////////////
// WEBPACK FOOTER
// ./~/airbnb-tracking/build/rum.js
// module id = 478
// module chunks = 168707334958949